import * as v from 'valibot'
import * as http from '@/util/http'

const IsAdminSchema = v.object({
  isAdmin: v.boolean(),
})

type IsAdmin = v.InferOutput<typeof IsAdminSchema>

export async function checkAdmin() {
  const { data } = await http.get<IsAdmin>('/api/v1/user/is-admin')
  if (!data.isAdmin) {
    throw new Response('not found', { status: 404 })
  }
}
